import bem from 'utils/bem';

export const block = bem('facebook-page-selector');
